import { defineMessages } from '@formatjs/intl';
import classNames from 'classnames';
import type { FC } from 'react';
import { memo } from 'react';
import { useIntl } from 'react-intl';

import { ReactComponent as IconArrowBack } from '../icons/icon-arrow-back-inline.svg';
import type { Topic } from '../types/api';
import { CategoryBadge } from './Category/CategoryBadge';

const messages = defineMessages({
  allTags: { defaultMessage: 'Toutes les étiquettes', id: 'Ajm3gL' },
});

interface Props {
  topic: Topic;
  className?: string;
}

export const CategoriesBlock: FC<Props> = memo(function CategoriesBlock(props) {
  const { topic, className } = props;
  const { formatMessage } = useIntl();
  return (
    <div className={classNames('categories flex flex-col items-start -mx-1', className)}>
      <div className="flex flex-wrap">
        {topic.categories
          ?.filter(cat => cat) //TODO: Quickfix for now, but need to investigate why we sometimes receive some null categories...
          .map(cat => (
            <CategoryBadge
              color="primary"
              variant="contained"
              {...cat}
              key={cat?.id}
              className="m-1"
            />
          ))}
      </div>
      <CategoryBadge
        icon={<IconArrowBack />}
        variant="contained"
        rootTags
        title={formatMessage(messages.allTags)}
        color="gray"
        className="gap-x-2 m-1 font-bold"
      />
    </div>
  );
});
